export default __webpack_public_path__ + "static/media/mauricioImage.6bc2b670.png";